import { render, staticRenderFns } from "./leftRightSwiperScroll.vue?vue&type=template&id=761c9bb2&scoped=true"
import script from "./leftRightSwiperScroll.vue?vue&type=script&lang=js"
export * from "./leftRightSwiperScroll.vue?vue&type=script&lang=js"
import style0 from "./leftRightSwiperScroll.vue?vue&type=style&index=0&id=761c9bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761c9bb2",
  null
  
)

export default component.exports